export default __webpack_public_path__ + "static/media/sudhi-sinha.51a441db.png";